import { mergeAttributes } from "@tiptap/core";
import { HorizontalRule as TiptapHorizontalRule } from "@tiptap/extension-horizontal-rule";

import { ActionButton } from "../../components";

export const HorizontalRule = TiptapHorizontalRule.extend({
	renderHTML() {
		return [
			"div",
			mergeAttributes(this.options.HTMLAttributes, {
				"data-type": this.name
			}),
			["hr"]
		];
	},
	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.setHorizontalRule(),
					icon: "Minus",
					shortcutKeys: ["mod", "alt", "S"],
					tooltip: t("editor.horizontalrule.tooltip")
				}
			})
		};
	},
	addKeyboardShortcuts() {
		return {
			"Mod-Alt-s": () => this.editor.commands.setHorizontalRule()
		};
	}
});
